import React from 'react';
import clsx from 'clsx';

export const NavButton = ({ 
  children, 
  onClick, 
  variant = 'default',
  className = '',
  ...props 
}) => {
  const getVariantClasses = () => {
    switch (variant) {
      case 'primary':
        return 'bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 focus:ring-white focus:ring-opacity-50';
      case 'dropdown':
        return 'flex items-center text-gray-300 hover:text-white';
      default:
        return 'text-gray-300 hover:text-white';
    }
  };

  return (
    <button 
      onClick={onClick} 
      className={clsx(
        'transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 rounded px-2 py-1',
        getVariantClasses(),
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};